<template>
  <div>
    <v-row class="mt-4 mb-8 pl-2" align="center">
      <v-icon large>mdi-clipboard-check-outline</v-icon>
      <h2 class="text-h5 pl-2">Módulo Relatórios PABX</h2>
    </v-row>
    <v-row no-gutters>
      <div class="text-h6">Relatório de Chamadas</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoRelatorioChamadas"
          :items="permissionsRelatorioChamadas"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Relatório de Conferências</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoRelatorioConferencias"
          :items="permissionsRelatorioConferencias"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>
    <!-- Selects Gerais -->
     <v-row no-gutters class="mt-n2">
      <div class="text-h6">Protocolo</div>
    </v-row>
    <v-row dense>
      <v-col cols="6">
        <v-select
          :disabled="
            (selecionadoRelatorioChamadas !==
              dictionaryRoles.relatorioChamadasVisualizarCondicionado.id &&
              selecionadoRelatorioChamadas !==
                dictionaryRoles.relatorioChamadasOuvirGravacao.id) ||
              permissaoVisualizar ||
              id == 1
          "
          dense
          v-model="selecionadoRelatorioChamadasProtocolo"
          :items="permissionsRelatorioChamadasProtocolo"
          label="Protocolos"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Ramais</div>
    </v-row>
    <v-row dense>
      <v-col cols="6">
        <v-autocomplete
          dense
          outlined
          label="Ramais Relatórios Chamadas"
          v-model="ramaisRelatoriosChamadas"
          :items="ramais"
          multiple
          class="mt-3"
          :disabled="
            (selecionadoRelatorioChamadas !==
              dictionaryRoles.relatorioChamadasVisualizarCondicionado.id &&
              selecionadoRelatorioChamadas !==
                dictionaryRoles.relatorioChamadasOuvirGravacao.id) ||
              permissaoVisualizar ||
              id == 1
          "
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.text }}</span>
            <v-chip v-if="index === 1" small>
              <span class="caption">
                (+{{ ramaisRelatoriosChamadas.length - 1 }})
              </span>
            </v-chip>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleRamaisRelatoriosChamadas">
              <v-list-item-action>
                <v-icon
                  :color="
                    ramaisRelatoriosChamadas.length > 0 ? 'indigo darken-4' : ''
                  "
                >
                  {{ iconRamaisRelatoriosChamadas }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Selecionar Todos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Tags dos relatórios de chamadas</div>
    </v-row>
    <v-row dense>
      <v-col cols="6">
        <v-autocomplete
          dense
          outlined
          label="Tags Relatórios Chamadas"
          v-model="tagsRelatoriosChamadas"
          :items="tags"
          multiple
          class="mt-3"
          :disabled="
            (selecionadoRelatorioChamadas !==
              dictionaryRoles.relatorioChamadasVisualizarCondicionado.id &&
              selecionadoRelatorioChamadas !==
                dictionaryRoles.relatorioChamadasOuvirGravacao.id) ||
              permissaoVisualizar ||
              id == 1
          "
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.text }}</span>
            <v-chip v-if="index === 1" small>
              <span class="caption">
                (+{{ tagsRelatoriosChamadas.length - 1 }})
              </span>
            </v-chip>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleTAGsRelatoriosPABX">
              <v-list-item-action>
                <v-icon
                  :color="
                    tagsRelatoriosChamadas.length > 0 ? 'indigo darken-4' : ''
                  "
                >
                  {{ iconTAGsRelatoriosPABX }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Selecionar Todos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Conferências</div>
    </v-row>
    <v-row dense>
      <v-col cols="6">
        <v-select
          dense
          outlined
          label="Conferências"
          v-model="conferenciasSelecionadas"
          :items="conferencias"
          multiple
          class="mt-3"
          :disabled="
            (selecionadoRelatorioConferencias !==
              dictionaryRoles.relatorioConferenciaVisualizarCondicionado.id &&
              selecionadoRelatorioConferencias !==
                dictionaryRoles.relatorioConferenciaOuvirGravacao.id) ||
              permissaoVisualizar ||
              id == 1
          "
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.text }}</span>
            <v-chip v-if="index === 1" small>
              <span class="caption">
                (+{{ conferenciasSelecionadas.length - 1 }})
              </span>
            </v-chip>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleConferencias">
              <v-list-item-action>
                <v-icon
                  :color="
                    conferenciasSelecionadas.length > 0 ? 'indigo darken-4' : ''
                  "
                >
                  {{ iconConferencias }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Selecionar Todos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { registerVuexModule } from "@/utils/vuexUtils";
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";
import { addAndRemovePermissions } from "../_utils/addAndRemovePermissions";
import { dictionaryRoles } from "../_utils/dictionaryRoles";

import roleStore from "../_store";

export default {
  data: () => ({
    dictionaryRoles: dictionaryRoles,
    permissaoVisualizar: false,
    initPermissoes: false,
    //Protocolo
    protocolo: [],
    protocoloSelecionados: [],
    initiatedProtocolo: false,
    // Select Ramal
    ramais: [],
    ramaisRelatoriosChamadas: [],
    initiatedRamais: false,
    // Select Tags
    tags: [],
    initiatedTags: false,
    tagsRelatoriosChamadas: [],
    // Select Conferências
    conferencias: [],
    conferenciasSelecionadas: [],
    initiatedConferencias: false,
    // Relatorio de Chamadas
    permissionsRelatorioChamadas: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text:
          dictionaryRoles.relatorioChamadasVisualizarCondicionado.description,
        value: dictionaryRoles.relatorioChamadasVisualizarCondicionado.id,
      },
      {
        text: dictionaryRoles.relatorioChamadasOuvirGravacao.description,
        value: dictionaryRoles.relatorioChamadasOuvirGravacao.id,
      },
      {
        text: dictionaryRoles.relatorioChamadasTotal.description,
        value: dictionaryRoles.relatorioChamadasTotal.id,
      },
    ],
    selecionadoRelatorioChamadas: null,
    // Relatorio de Conferências
    permissionsRelatorioConferencias: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text:
          dictionaryRoles.relatorioConferenciaVisualizarCondicionado
            .description,
        value: dictionaryRoles.relatorioConferenciaVisualizarCondicionado.id,
      },
      {
        text: dictionaryRoles.relatorioConferenciaOuvirGravacao.description,
        value: dictionaryRoles.relatorioConferenciaOuvirGravacao.id,
      },
      {
        text: dictionaryRoles.relatorioConferenciaTotal.description,
        value: dictionaryRoles.relatorioConferenciaTotal.id,
      },
    ],
    selecionadoRelatorioConferencias: null,
    permissionsRelatorioChamadasProtocolo: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text:
          dictionaryRoles.relatorioPABXChamadasProtocolo.description,
        value: dictionaryRoles.relatorioPABXChamadasProtocolo.id,
      }
    ],
    selecionadoRelatorioChamadasProtocolo: null,
  }),

  computed: {
    ...mapGetters("moduloPABXStepStore", [
      "getRamais",
      "getTags",
      "getConferencias",
      "getSelectedRamaisRelatoriosPABX",
      "getSelectedTagsRelatoriosPABX",
      "getSelectedConferencias",
      "getPermissoes",
    ]),

    todosRamaisRelatoriosChamadasSelecionados() {
      return this.ramaisRelatoriosChamadas.length === this.ramais.length;
    },
    algunsRamaisRelatoriosChamadasSelecionados() {
      return (
        this.ramaisRelatoriosChamadas.length > 0 &&
        !this.todosRamaisRelatoriosChamadasSelecionados
      );
    },
    iconRamaisRelatoriosChamadas() {
      if (this.todosRamaisRelatoriosChamadasSelecionados)
        return "mdi-close-box";
      if (this.algunsRamaisRelatoriosChamadasSelecionados)
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    todasTAGsRelatoriosPABXSelecionadas() {
      return this.tagsRelatoriosChamadas.length === this.tags.length;
    },
    algumasTAGsRelatoriosPABXSelecionadas() {
      return (
        this.tagsRelatoriosChamadas.length > 0 &&
        !this.todasTAGsRelatoriosPABXSelecionadas
      );
    },
    iconTAGsRelatoriosPABX() {
      if (this.todasTAGsRelatoriosPABXSelecionadas) return "mdi-close-box";
      if (this.algumasTAGsRelatoriosPABXSelecionadas) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    todasConferenciasSelecionadas() {
      return this.conferenciasSelecionadas.length === this.conferencias.length;
    },
    algumasConferenciasSelecionadas() {
      return (
        this.conferenciasSelecionadas.length > 0 &&
        !this.todasConferenciasSelecionadas
      );
    },
    iconConferencias() {
      if (this.todasConferenciasSelecionadas) return "mdi-close-box";
      if (this.algumasConferenciasSelecionadas) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },

  async created() {
    this.initPermissao = false;

    registerVuexModule(this.$store, "moduloPABXStepStore", roleStore);

    const verifyRamaisVuex = this.getRamais.length;
    const verifyTagsVuex = this.getTags.length;
    const verifyConferenciasVuex = this.getConferencias.length;

    if (
      verifyRamaisVuex === 0 &&
      verifyTagsVuex === 0 &&
      verifyConferenciasVuex === 0
    ) {
      await Promise.all([
        this.listAllRamais(),
        this.listAllTags(),
        this.listAllConferencias(),
      ]);
    } else if (
      verifyRamaisVuex !== 0 &&
      verifyTagsVuex === 0 &&
      verifyConferenciasVuex === 0
    ) {
      await Promise.all([this.listAllTags(), this.listAllConferencias()]);
    } else if (
      verifyRamaisVuex === 0 &&
      verifyTagsVuex !== 0 &&
      verifyConferenciasVuex === 0
    ) {
      await Promise.all([this.listAllRamais(), this.listAllConferencias()]);
    } else if (
      verifyRamaisVuex === 0 &&
      verifyTagsVuex === 0 &&
      verifyConferenciasVuex !== 0
    ) {
      await Promise.all([this.listAllRamais(), this.listAllTags()]);
    } else if (
      verifyRamaisVuex === 0 &&
      verifyTagsVuex !== 0 &&
      verifyConferenciasVuex !== 0
    ) {
      await this.listAllRamais();
    } else if (
      verifyRamaisVuex !== 0 &&
      verifyTagsVuex === 0 &&
      verifyConferenciasVuex !== 0
    ) {
      await this.listAllTags();
    } else if (
      verifyRamaisVuex !== 0 &&
      verifyTagsVuex !== 0 &&
      verifyConferenciasVuex === 0
    ) {
      await this.listAllConferencias();
    }

    this.ramais = this.getRamais.map((ramal) => ({
      text: ramal.numero,
      value: ramal._id,
    }));
    this.tags = this.getTags.map((tag) => ({
      text: tag.description,
      value: tag._id,
    }));
    this.conferencias = this.getConferencias.map((conferencia) => ({
      text: conferencia.description,
      value: conferencia._id,
    }));

    this.ramaisRelatoriosChamadas = this.getSelectedRamaisRelatoriosPABX;
    this.tagsRelatoriosChamadas = this.getSelectedTagsRelatoriosPABX;
    this.conferenciasSelecionadas = this.getSelectedConferencias;

    const arrayPermissions = this.arrayPermissionsFromLocalStorage();
    if (
      arrayPermissions.includes(
        process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_VISUALIZAR
      )
    ) {
      this.permissaoVisualizar = true;
    }
  },

  methods: {
    ...mapActions("moduloPABXStepStore", [
      "listAllRamais",
      "listAllTags",
      "listAllConferencias",
      "setSelectedRamaisRelatoriosPABX",
      "setSelectedTagsRelatoriosPABX",
      "setSelectedConferencias",
      "addPermissionsID",
      "deletePermissionsID",
    ]),
    ...obtainUserPermissions,
    ...addAndRemovePermissions,

    toggleRamaisRelatoriosChamadas() {
      this.$nextTick(() => {
        if (this.todosRamaisRelatoriosChamadasSelecionados) {
          this.ramaisRelatoriosChamadas.splice(0);
        } else {
          this.ramaisRelatoriosChamadas.splice(0);
          this.ramaisRelatoriosChamadas = this.ramais.map(
            (ramal) => ramal.value
          );
        }
      });
    },
    toggleTAGsRelatoriosPABX() {
      this.$nextTick(() => {
        if (this.todasTAGsRelatoriosPABXSelecionadas) {
          this.tagsRelatoriosChamadas.splice(0);
        } else {
          this.tagsRelatoriosChamadas.splice(0);
          this.tagsRelatoriosChamadas = this.tags.map((tag) => tag.value);
        }
      });
    },
    toggleConferencias() {
      this.$nextTick(() => {
        if (this.todasConferenciasSelecionadas) {
          this.conferenciasSelecionadas.splice(0);
        } else {
          this.conferenciasSelecionadas.splice(0);
          this.conferenciasSelecionadas = this.conferencias.map(
            (conferencia) => conferencia.value
          );
        }
      });
    },
  },

  watch: {
    ramaisRelatoriosChamadas: {
      deep: true,
      async handler() {
        await this.setSelectedRamaisRelatoriosPABX(
          this.ramaisRelatoriosChamadas
        );
      },
    },
    tagsRelatoriosChamadas: {
      deep: true,
      async handler() {
        await this.setSelectedTagsRelatoriosPABX(this.tagsRelatoriosChamadas);
      },
    },
    conferenciasSelecionadas: {
      deep: true,
      async handler() {
        await this.setSelectedConferencias(this.conferenciasSelecionadas);
      },
    },
    getSelectedRamaisRelatoriosPABX: {
      deep: true,
      handler() {
        if (!this.initiatedRamais) {
          this.ramaisRelatoriosChamadas = [
            ...this.getSelectedRamaisRelatoriosPABX,
          ];
          this.initiatedRamais = true;
        }
      },
    },
    getSelectedTagsRelatoriosPABX: {
      deep: true,
      handler() {
        if (!this.initiatedTags) {
          this.tagsRelatoriosChamadas = [...this.getSelectedTagsRelatoriosPABX];
          this.initiatedTags = true;
        }
      },
    },
    getSelectedConferencias: {
      deep: true,
      handler() {
        if (!this.initiatedConferencias) {
          this.conferenciasSelecionadas = [...this.getSelectedConferencias];
          this.initiatedConferencias = true;
        }
      },
    },

    // Monitora permissoes
    getPermissoes: {
      deep: true,
      handler(newValue) {
        if (!this.initPermissoes) {
          this.initPermissoes = true;
          // Relatorio de Chamadas
          if (
            newValue.includes(
              dictionaryRoles.relatorioChamadasVisualizarCondicionado.id
            )
          ) {
            this.selecionadoRelatorioChamadas =
              dictionaryRoles.relatorioChamadasVisualizarCondicionado.id;
          } else if (
            newValue.includes(dictionaryRoles.relatorioChamadasOuvirGravacao.id)
          ) {
            this.selecionadoRelatorioChamadas =
              dictionaryRoles.relatorioChamadasOuvirGravacao.id;
          } else if (
            newValue.includes(dictionaryRoles.relatorioChamadasTotal.id)
          ) {
            this.selecionadoRelatorioChamadas =
              dictionaryRoles.relatorioChamadasTotal.id;
          }
          // Relatorio de Conferências
          if (
            newValue.includes(
              dictionaryRoles.relatorioConferenciaVisualizarCondicionado.id
            )
          ) {
            this.selecionadoRelatorioConferencias =
              dictionaryRoles.relatorioConferenciaVisualizarCondicionado.id;
          } else if (
            newValue.includes(
              dictionaryRoles.relatorioConferenciaOuvirGravacao.id
            )
          ) {
            this.selecionadoRelatorioConferencias =
              dictionaryRoles.relatorioConferenciaOuvirGravacao.id;
          } else if (
            newValue.includes(dictionaryRoles.relatorioConferenciaTotal.id)
          ) {
            this.selecionadoRelatorioConferencias =
              dictionaryRoles.relatorioConferenciaTotal.id;
          }
          if (newValue.includes(dictionaryRoles.relatorioPABXChamadasProtocolo.id)) {
            this.selecionadoRelatorioChamadasProtocolo = dictionaryRoles.relatorioPABXChamadasProtocolo.id;
          }
        }
      },
    },

    //Monitora Selects
    selecionadoRelatorioChamadas: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
        if(newValue !== 47 && newValue !== 48 && newValue !== 49){
          this.selecionadoRelatorioChamadasProtocolo = null
        }
      },
    },
    selecionadoRelatorioChamadasProtocolo:{
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoRelatorioConferencias: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
  },
};
</script>
